export const ID = '25e42328-9623-45cc-b79d-1b4a325ea2c2';

export const NAME = 'StorageMart Header';
